import { Message, useChannelStateContext } from 'stream-chat-react';

import { CloseThreadButton } from '../TeamChannelHeader/CloseThreadButton';
import type { StreamChatType } from '../../types';
import { TeamMessage } from '../TeamMessage/TeamMessage';

import { useWorkspaceController } from '../../context/WorkspaceController';
import { Box, Button, Typography } from '@mui/material';
import { Close, InfoOutlined } from '@mui/icons-material';

export const PinnedMessageList = () => {
  const { pinnedMessageListOpen, togglePinnedMessageListOpen } = useWorkspaceController();
  const { channel } = useChannelStateContext<StreamChatType>();

  if (!pinnedMessageListOpen) return null;

  return (
    <div className='pinned-messages__container'>
      <div className='pinned-messages__header'>
        <div className='workspace-header__title'>Pins</div>
        <Button size="small" endIcon={<Close />} color="primary" variant="contained" onClick={togglePinnedMessageListOpen} >Close</Button>
      </div>
      <div className='pinned-messages__list'>
        {channel.state.pinnedMessages.map((message) => (
          <Message
            groupStyles={['single']}
            Message={TeamMessage}
            key={message.id}
            message={message}
          />
        ))}
        {
          channel.state.pinnedMessages.length === 0 && (
            <Box
              sx={{
                textAlign: 'center',
                m: 4,
              }}
            >
              <InfoOutlined
                sx={{
                  fontSize: 40,
                  fontWeight: 300,
                }}
                color="secondary"
              />
              <Typography
                variant="subtitle1"
                align="center"
                component="div"
                color="secondary"
                sx={{
                  mt: 2,
                  fontWeight: 300,
                }}
              >
                No Pinned Messages
              </Typography>
            </Box>
          )
        }
      </div>
    </div>
  );
};
